import {
  FormField,
  FormItem,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import { Minus, Plus, Users } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";

const presets = [2, 4, 6, 8, 10, 15, 20];

export const Step4GuestCount = () => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="guestCount"
      render={({ field }) => (
        <FormItem className="space-y-6 w-full">
          <div className="flex flex-col gap-1 mb-2">
            <h1 className="font-h2 text-dark-blue">Combien de convives ?</h1>
            <p className="font-p text-muted-foreground">
              Nombre de personnes à votre table.
            </p>
          </div>

          <FormControl>
            {/* Stepper principal */}
            <div className="bg-white border-2 border-border rounded-2xl p-6 flex items-center justify-between gap-4">
              <button
                type="button"
                onClick={() => field.onChange(Math.max((field.value || 1) - 1, 1))}
                disabled={(field.value || 1) <= 1}
                className="w-12 h-12 rounded-xl border-2 border-border flex items-center justify-center hover:border-primary hover:text-primary transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <Minus size={20} />
              </button>

              <div className="flex flex-col items-center gap-1">
                <div className="flex items-end gap-2">
                  <AnimatePresence mode="popLayout" initial={false}>
                    <motion.span
                      key={field.value || 1}
                      initial={{ y: 12, opacity: 0, scale: 0.9 }}
                      animate={{ y: 0, opacity: 1, scale: 1 }}
                      exit={{ y: -12, opacity: 0, scale: 0.9 }}
                      transition={{ type: "spring", stiffness: 360, damping: 26 }}
                      className="text-5xl font-bold text-dark-blue leading-none tabular-nums"
                    >
                      {field.value || 1}
                    </motion.span>
                  </AnimatePresence>
                  <span className="text-muted-foreground font-medium pb-1">pers.</span>
                </div>
                <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                  <Users size={12} />
                  {(field.value || 1) <= 6 ? "Petit groupe" : (field.value || 1) <= 15 ? "Groupe moyen" : "Grand groupe"}
                </div>
              </div>

              <button
                type="button"
                onClick={() => field.onChange((field.value || 1) + 1)}
                className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center hover:bg-primary/90 transition-colors"
              >
                <Plus size={20} />
              </button>
            </div>
          </FormControl>

          {/* Raccourcis */}
          <div className="space-y-2">
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Sélection rapide</p>
            <div className="flex flex-wrap gap-2">
              {presets.map((n) => (
                <button
                  key={n}
                  type="button"
                  onClick={() => field.onChange(n)}
                  className={`px-3.5 py-1.5 rounded-full text-sm font-medium border transition-all ${
                    field.value === n
                      ? "bg-primary text-white border-primary"
                      : "bg-white border-border text-dark-blue hover:border-primary/50 hover:bg-primary/5"
                  }`}
                >
                  {n}
                </button>
              ))}
            </div>
          </div>

          <FormMessage />
        </FormItem>
      )}
    />
  );
};
